<script>
    import { setContext, onMount, onDestroy, getContext } from 'svelte'
    import { writable } from 'svelte/store'
    export let value = null
    export let name = null
    export let label = null
    export let disabled = false
    export let required = false
    export let validation = null
    export let valid = null
    export let style = ''
    export let alignOptions = false
    import Typography from './Typography.svelte'
    let radioValue = writable(value)
    let radioDisabled = writable(disabled)
    let radioLabel = writable('')
    setContext('radioValue', radioValue)
    setContext('radioDisabled', radioDisabled)
    setContext('radioLabel', radioLabel)
    let formData = getContext('formData')
    $: if (disabled || !disabled) {
        radioDisabled.update((_) => disabled)
    }
    $: value = $radioValue
    $: if (value) updateState()
    function updateState() {
        if (name && formData)
            formData.update((x) => {
                return Object.assign(
                    x,
                    Object.fromEntries([
                        [
                            name,
                            {
                                valid: !!valid,
                                validation: !!validation,
                                required,
                                value,
                                label,
                                labelOption: $radioLabel,
                            },
                        ],
                    ])
                )
            })
    }
    onMount((_) => {
        updateState()
    })
    onDestroy((_) => {
        if (name && formData) {
            formData.update((all) => {
                return Object.fromEntries(
                    Object.entries(all).filter(([n]) => name != n)
                )
            })
        }
    })
    $: value = $radioValue
</script>

<div class:disabled {style}>
    {#if label}
        <Typography type="body">{label}</Typography>
    {/if}
    <div
        style={`flex-direction: ${alignOptions ? 'row' : 'column'}`}
        class="container"
    >
        <slot />
    </div>
</div>

<style>
    div {
        display: flex;
        flex-direction: column;
        gap: 10px;
        user-select: none;
    }
    .disabled {
        cursor: no-drop;
    }

    .container {
        display: flex;
    }
</style>
